import React, { useContext } from "react";
import { AppContext } from "../../../lib";
import { TrashIcon } from "../../../assets/svgs";
import "./CampaignSpecialBuyCondition.scss";

export default function CampaignSpecialBuyCondition({
  specialCondition,
  campaign,
}) {
  const { dispatch } = useContext(AppContext);
  const { title } = specialCondition;
  const { archived, id: campaignID } = campaign;

  const askToUnarchive = () =>
    dispatch({
      type: "setActiveAlert",
      payload: {
        message:
          "This campaign is archived. Please unarchive this campaign to make this edit.",
      },
    });

  const removeSpecialCondition = () =>
    archived
      ? askToUnarchive()
      : dispatch({
          type: "removeSpecialCondition",
          payload: { campaignID, specialCondition },
        });

  return (
    <div className="campaignCollectionItem">
      <span className="campaignCollectionItem-label">{title}</span>
      <button
        className="campaignCollectionItem-remove"
        title={`Remove ${title}`}
        onClick={removeSpecialCondition}
      >
        <TrashIcon />
      </button>
    </div>
  );
}
